import React from "react";
import { FiSlash } from "react-icons/fi";

import type { TableRecord } from "../model/types";

/**
 * Generation status is an axis ORTHOGONAL to node type (hub/sat/link/manual).
 * `generate_model_entity` controls whether automation emits SQL for the entity; it does
 * NOT change what the entity IS. So it is rendered as a lightweight overlay on top of the
 * real node — dimmed + dashed + a "Not generated" badge — instead of collapsing the entity
 * into a different node type (which would hide its relationships/lineage).
 */
const isFlagEnabled = (value: string | null | undefined): boolean => {
  if (!value) {
    return false;
  }
  const normalized = value.trim().toLowerCase();
  return normalized === "y" || normalized === "yes" || normalized === "true";
};

export const isGenerateEnabled = (record: TableRecord): boolean =>
  isFlagEnabled(record.generate_model_entity);

/** Extra classes to layer on a node container when the entity is not generated. */
export const notGeneratedNodeClasses = (record: TableRecord): string =>
  isGenerateEnabled(record) ? "" : "tw-opacity-60 tw-border-dashed";

/** Small badge shown on a node when the entity is not generated. */
export function NotGeneratedBadge({ record }: { record: TableRecord }): JSX.Element | null {
  if (isGenerateEnabled(record)) {
    return null;
  }
  return (
    <div className="tw-absolute tw-left-4 tw-top-4 tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-slate-300 tw-bg-white/90 tw-px-2 tw-py-1 tw-text-[10px] tw-font-semibold tw-text-slate-500">
      <FiSlash className="tw-h-3 tw-w-3" />
      <span>Not generated</span>
    </div>
  );
}
